import * as _ from 'lodash';
import React, { Fragment, useState } from 'react';
import { IChainStartItem } from './models';
import { ClusterStatus } from '@nkr/enums/index';
import { Button, Glyphicon, Panel, Row } from 'react-bootstrap';
import { TableWrapper } from './styles';
import { IListItem } from '@nkr/models/list-item';
import { IMatchRunScenario } from '@nkr/models/matching';
import ChainStartRow from './chain-start-row';

interface IProps {
    suppress: boolean,
    checkAllChainStarts: boolean,
    sortedChainStarts: IChainStartItem[],
    clusterStatusList: IListItem[],
    scenario: IMatchRunScenario | { stalled: false; },
    onSuppress: () => void,
    onCheckStalled: () => void,
    onCheckAllChainStarts: () => void,
    onChainStartSelect: (id: number) => void,
    onCommentChange: (clusterId: number, comment: string) => void,
    onClusterStatusChange: (clusterId: number, clusterStatus: number) => void
}

const ChainStarts = (props: IProps) => {
    let suppressButtonTitle = props.suppress ? 'Unsuppress' : 'Suppress';
    let currentStatus = ClusterStatus.Stalled;

    return (
        <Panel style={{ marginBottom: 0 }}>
            <Panel.Heading style={{ textAlign: 'right', padding: '5px 5px' }}>
                {/* <div style={{ display: 'flex', justifyContent: 'flex-end', marginBottom: 20 }}>
                    <Button bsStyle='primary' bsSize='xs' style={{ marginRight: 10 }} onClick={props.onSuppress}>{suppressButtonTitle}</Button>
                    <Button bsStyle='primary' bsSize='xs' onClick={props.onCheckStalled}>Check Stalled</Button>
                </div> */}

                <div style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center', fontSize: 12 }}>
                    <div
                        title='Any AB donor, any A donor over age 55, or any B donor over age 65.'
                        style={{ display: 'flex', alignItems: 'center' }}
                    >
                        <div
                            style={{
                                height: 20,
                                width: 20,
                                backgroundColor: 'yellow',
                                border: '1px solid #ddd',
                                marginRight: 5,
                                borderRadius: 4
                            }}
                        />
                        <div>Any AB donor, any A donor over age 55, or any B donor over age 65.</div>
                    </div>

                    <div
                        title='Donor is within 28 calendar days of the last day of their donation range'
                        style={{ display: 'flex', alignItems: 'center' }}
                    >
                        <div
                            style={{
                                height: 20,
                                width: 20,
                                backgroundColor: 'green',
                                border: '1px solid #ddd',
                                marginRight: 5,
                                borderRadius: 4
                            }}
                        />
                        <div>Donor is within 28 calendar days of the last day of their donation range</div>
                    </div>

                    <div
                        title='Chain Starter with < one-week donation range.'
                        style={{ display: 'flex', alignItems: 'center' }}
                    >
                        <div
                            style={{
                                height: 20,
                                width: 20,
                                backgroundColor: '#adadeb',
                                border: '1px solid #ddd',
                                marginRight: 5,
                                borderRadius: 4
                            }}
                        />
                        <div>CS &lt; 5 business days</div>
                    </div>

                    <div style={{ display: 'flex', justifyContent: 'flex-end', alignItems: 'center' }}>
                        <Button bsStyle='primary' bsSize='xs' style={{ marginRight: 10 }} onClick={props.onSuppress}>{suppressButtonTitle}</Button>
                        <Button bsStyle='primary' bsSize='xs' onClick={props.onCheckStalled}>Check Stalled</Button>
                    </div>
                </div>
            </Panel.Heading>
            <Panel.Body>
                <TableWrapper condensed>
                    <thead>
                        <tr>
                            <th style={{ width: '5%' }}>Rank #</th>
                            <th style={{ width: '5%' }}>Chain</th>
                            <th style={{ width: '5%' }}>Type</th>
                            <th>Center Alias</th>
                            <th>Donor Alias</th>
                            <th style={{ width: '3%' }}>Age</th>
                            <th style={{ width: '3%' }}>ABO</th>
                            <th>Cluster Status</th>
                            <th>Earliest<br />Donation Date</th>
                            <th>Latest<br />Donation Date</th>
                            {/* <th onClick={() => handleSort('min')}>Min {renderSort('min')}</th> */}
                            <th>Min</th>
                            <th>Max</th>
                            <th style={{ width: '12%' }}>Comments</th>
                            <th style={{ width: '1%', cursor: 'default' }} onClick={props.onCheckAllChainStarts}>All <Glyphicon glyph={!props.checkAllChainStarts ? 'unchecked' : 'check'} /></th>
                        </tr>
                    </thead>
                    <tbody>
                        {props.sortedChainStarts.map((item, index) => {
                            if (item.donor.cluster.clusterStatusId != currentStatus) {
                                currentStatus = item.donor.cluster.clusterStatusId;

                                return (
                                    <Fragment key={'chain-start-' + index}>
                                        {index > 0 && (
                                            <tr>
                                                <td colSpan={15} style={{ backgroundColor: 'black', height: 1, padding: 1, margin: 0 }}></td>
                                            </tr>
                                        )}
                                        <ChainStartRow
                                            index={index}
                                            item={item}
                                            clusterStatusList={props.clusterStatusList}
                                            scenario={props.scenario}
                                            onClusterStatusChange={props.onClusterStatusChange}
                                            onCommentChange={props.onCommentChange}
                                            onSelected={props.onChainStartSelect}
                                        />
                                    </Fragment>
                                );
                            }

                            return (
                                <ChainStartRow
                                    key={'chain-start-' + index}
                                    index={index}
                                    item={item}
                                    clusterStatusList={props.clusterStatusList}
                                    scenario={props.scenario}
                                    onClusterStatusChange={props.onClusterStatusChange}
                                    onCommentChange={props.onCommentChange}
                                    onSelected={props.onChainStartSelect}
                                />
                            );
                        })}
                    </tbody>
                </TableWrapper>
            </Panel.Body>
        </Panel>
    );
}

export default ChainStarts;